import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M6.53 8.804q.13.002.252.053a.67.67 0 0 1 .36.36q.053.122.054.254v3.667a.667.667 0 0 1-1.334 0v-2.06L2.477 14.47a.67.67 0 0 1-1.144-.474.67.67 0 0 1 .196-.473l3.394-3.386h-2.06a.667.667 0 0 1 0-1.334zM13.996 1.333a.67.67 0 0 1 .62.414.67.67 0 0 1-.146.73l-3.331 3.325h2.06a.668.668 0 0 1 0 1.333H9.531a.67.67 0 0 1-.613-.413.7.7 0 0 1-.054-.253V2.802a.668.668 0 0 1 1.138-.472.67.67 0 0 1 .195.472v2.06l3.325-3.332a.67.67 0 0 1 .473-.197" }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })